import bowser from 'bowser'

import './IncompatibleBrowserBar.scss'

const lego = window.lego

const isOldChrome = bowser.chrome && bowser.version <= 30
const isOldSafari = bowser.safari && bowser.version <= 8
const isOldFirefox = bowser.firefox && bowser.version <= 20
const isOldAndroid = bowser.android && bowser.version <= 3
const isOldIOS = bowser.ios && bowser.version <= 3
const isOldIE = bowser.msie && bowser.version <= 10

if (isOldChrome || isOldSafari || isOldFirefox || isOldAndroid || isOldIOS || isOldIE) {
  const container = document.createElement('div')

  container.innerHTML = [
    '<div class="IncompatibleBrowserBar">',
    '<div class="IncompatibleBrowserBar-content">',
    '<div class="IncompatibleBrowserBar-copy">',
    '<div class="IncompatibleBrowserBar-title">Outdated Browser Detected</div>',
    '<div>',
    'You may not get the best experience of this website due to an outdated browser.',
    'Download and use a newer version of one of these popular, free browsers:',
    '</div>',
    '</div>',
    '<div class="IncompatibleBrowserBar-browserArea">',
    '<a',
    'class="IncompatibleBrowserBar-browser"',
    'href="https://www.google.com/chrome/browser/"',
    'target="_blank"',
    '>',
    '<img',
    'class="IncompatibleBrowserBar-browserLogo"',
    `src="${lego.config.ASSET_DOMAIN}/images/logo-chrome.png"`,
    'alt="Google Chrome"',
    '/>',
    '<span class="IncompatibleBrowserBar-browserDetails">',
    '<span class="IncompatibleBrowserBar-downloadLink">Download</span><br />',
    '<span class="IncompatibleBrowserBar-browserName">Chrome</span>',
    '</span>',
    '</a>',
    '<a',
    'class="IncompatibleBrowserBar-browser"',
    'href="https://www.mozilla.org/firefox"',
    'target="_blank"',
    '>',
    '<img',
    'class="IncompatibleBrowserBar-browserLogo"',
    `src="${lego.config.ASSET_DOMAIN}/images/logo-firefox.png"`,
    'alt="Google Chrome"',
    '/>',
    '<span class="IncompatibleBrowserBar-browserDetails">',
    '<span class="IncompatibleBrowserBar-downloadLink">Download</span><br />',
    '<span class="IncompatibleBrowserBar-browserName">Firefox</span>',
    '</span>',
    '</a>',
    '</div>',
    '</div>',
    '</div>',
  ].join(' ')

  window.onload = () => {
    document.body.insertBefore(container, document.body.childNodes[0])
  }
}
